import Vue from 'vue'
import configs from '@/config'

const { publicDocumentSystemApiUrl } = configs

const docsys = `${publicDocumentSystemApiUrl}/api/docsys`
const uploadUrl = `${docsys}/document-system/api/file`
const importJobUrl = `${docsys}/ahaslides/api/import-job`

let resource = null

export const actions = {
  uploadFile: {
    method: 'POST',
    url: uploadUrl,
  },
  cloudImport: {
    method: 'POST',
    url: `${docsys}/document-system/api/cloud-import`,
  },
  importAsync: {
    method: 'POST',
    url: `${docsys}/ahaslides/api/file:import-async`,
  },
  cloudImportStatus: {
    method: 'GET',
    url: `${uploadUrl}/{hashId}`,
  },
  importJobStatus: {
    method: 'GET',
    url: `${importJobUrl}/{jobId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const uploadFile = async (formData) => {
  const res = await resource.uploadFile({}, formData)
  return res.body
}

const cloudImport = async (params) => {
  const res = await resource.cloudImport({}, params)
  return res.body
}

const importAsync = async (params) => {
  const res = await resource.importAsync({}, params)
  return res.body
}

const getCloudImportStatus = async (hashId) => {
  const res = await resource.cloudImportStatus({ hashId })
  return res.body
}

const getImportJobStatus = async (jobId) => {
  const res = await resource.importJobStatus({ jobId })
  return res.body
}

export default {
  initResource,
  uploadFile,
  cloudImport,
  importAsync,
  getCloudImportStatus,
  getImportJobStatus,
}
